import styled from 'styled-components'

export const StyledNewsSavedSearchActions = styled.div`
  display: flex;
`
